import React from 'react'

import { CircleIcon } from 'components/styled/icon/candidate-stage/circle-icon'
import { ThemeColor } from 'theme/colors'
import { Icon } from 'components/styled/icon'
import styled from 'styled-components'

export enum CandidateStages {
  New = 'new',
  Proceed = 'proceed',
  PersonalInterview = 'personalinterview',
  Hired = 'hired',
  Rejected = 'rejected',
  Withdrawn = 'withdrawn',
  Custom = 'custom',
}

export interface StageIconProps {
  stage: CandidateStages
  customStage?: {
    currStageNum: number
    numOfStages: number
  }
}

const getIcon = (stage: CandidateStages): string | undefined => {
  switch (stage) {
    case CandidateStages.Rejected:
      return 'close'
    case CandidateStages.Withdrawn:
      return 'not_interested'
    case CandidateStages.Hired:
      return 'check'
    default:
      return undefined
  }
}

const getColor = (stage: CandidateStages): ThemeColor | undefined => {
  switch (stage) {
    case CandidateStages.New:
      return 'grey50'
    case CandidateStages.Proceed:
    case CandidateStages.PersonalInterview:
    case CandidateStages.Custom:
      return 'secondary110'
    case CandidateStages.Rejected:
      return 'error110'
    case CandidateStages.Withdrawn:
      return 'warn110'
    case CandidateStages.Hired:
      return 'success110'
    default:
      return undefined
  }
}

const getPercentage = (
  stage: CandidateStages,
  customStage: StageIconProps['customStage']
): number => {
  switch (stage) {
    case CandidateStages.Custom:
      return customStage
        ? Math.ceil(
            (customStage?.currStageNum / customStage?.numOfStages) * 100
          )
        : 100
    case CandidateStages.Proceed:
      return 33
    case CandidateStages.PersonalInterview:
      return 66
    case CandidateStages.New:
    case CandidateStages.Rejected:
    case CandidateStages.Withdrawn:
    case CandidateStages.Hired:
    default:
      return 100
  }
}

const StyledStageIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.color.white};
`

const StageFillIcon = styled(Icon)`
  position: absolute;
`

export const StageIcon: React.FC<StageIconProps> = ({ stage, customStage }) => {
  const color = getColor(stage)
  const percentage = getPercentage(stage, customStage)

  const isFilled = [
    CandidateStages.Withdrawn,
    CandidateStages.Hired,
    CandidateStages.Rejected,
  ].includes(stage)

  const iconType = getIcon(stage)

  return (
    <StyledStageIcon>
      <CircleIcon
        size={14}
        stroke={3}
        color={color}
        percentage={percentage}
        isFilled={isFilled}
      />
      {iconType && <StageFillIcon type={iconType} size="s12" />}
    </StyledStageIcon>
  )
}
